/* eslint-disable no-confusing-arrow */
// import clsx from "clsx";
import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Col, Input, Label, Navbar } from "reactstrap";
import { ReactComponent as Logo } from "../../../assets/images/logo/logo.svg";

const LoginFooter = () => {
  return (
    <footer className="LoginFooter">
      <div className="container login-wrapper">
        <div className="row">
          <div className="col-12 col-lg-4 text-center text-lg-start">
            <h2 className="f-title">Contact</h2>
            <div className="address">
              <p>3600 Clipper Mill Rd.</p>
              <p>Baltimore, MD 21211</p>
            </div>
            <div className="contact-info">
              {/* <p>E: hello@uncutgems.com</p> */}
              {/* <p>P: +(12) 989 98989</p> */}
            </div>
          </div>
          <div className="col-12 col-lg-4  mt-1 mt-lg-0">
            <div className="f-logo text-center">
              <Logo />
              <p>
                Video editing partner to thousands of videographers worldwide.
              </p>
            </div>
          </div>
          <div className="col-12 col-lg-4 text-center text-lg-end">
            <h2 className="f-title">Help & Support</h2>
            <ul className="list-style-icons p-0 support-links">
              <li>
                <a href="#" target="_blank">
                  Tutorials
                </a>
              </li>
              <li>
                <a href="#" target="_blank">
                  Video FAQs
                </a>
              </li>
              <li>
                <a href="#" target="_blank">
                  Carat Club FAQs
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="row Subscribe-bk mt-1 mt-lg-0 d-none">
          <Col className="mb-0 mb-lg-1" sm="12">
            <Label className="form-label" for="basicInput">
              Subscribe to newsletter
            </Label>
            <Input type="email" id="basicInput" placeholder="Enter you email" />
            <button className="btn mt-1 mt-md-0 ">Subscribe</button>
          </Col>
        </div>
        <div className="footer-info g-0 row">
          <div className="col-12 col-lg-4 ">
            <ul className="list-style-icons p-0 m-0 footer-links position-relative text-center text-lg-start">
              <li>
                <a href="#" target="_blank">
                  Terms & Conditions
                </a>
              </li>
              <hr />
              <li>
                <a href="#" target="_blank">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
          <div className="col-12 col-lg-4 text-center copyright">
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.2647 6.77858C6.29764 6.56117 6.37011 6.37011 6.46235 6.20541C6.55458 6.0407 6.68635 5.90235 6.85105 5.79694C7.00917 5.69811 7.20682 5.652 7.45058 5.64541C7.60211 5.652 7.74047 5.67835 7.86564 5.73105C7.99741 5.79035 8.116 5.86941 8.20823 5.96823C8.30047 6.06705 8.37294 6.18564 8.43223 6.31741C8.49152 6.44917 8.51788 6.59411 8.52447 6.73905H9.70376C9.69058 6.42941 9.63129 6.14611 9.51929 5.88917C9.40729 5.63223 9.25576 5.40823 9.05811 5.22376C8.86047 5.03929 8.62329 4.89435 8.34658 4.78894C8.06988 4.68352 7.76682 4.63741 7.43082 4.63741C7.00258 4.63741 6.62705 4.70988 6.31082 4.86141C5.99458 5.01294 5.73105 5.21058 5.52023 5.46752C5.30941 5.72447 5.15129 6.02094 5.05247 6.36352C4.95364 6.70611 4.89435 7.06188 4.89435 7.444V7.62188C4.89435 8.004 4.94705 8.35976 5.04588 8.70235C5.1447 9.04494 5.30282 9.34141 5.51364 9.59176C5.72447 9.84211 5.988 10.0463 6.30423 10.1913C6.62047 10.3362 6.996 10.4153 7.42423 10.4153C7.73388 10.4153 8.02376 10.3626 8.29388 10.2638C8.564 10.1649 8.80117 10.0266 9.00541 9.8487C9.20964 9.67082 9.37435 9.46658 9.49294 9.22941C9.61152 8.99223 9.684 8.74188 9.69058 8.47176H8.51129C8.5047 8.61011 8.47176 8.73529 8.41247 8.85388C8.35317 8.97247 8.27411 9.07129 8.17529 9.15694C8.07647 9.24258 7.96447 9.30847 7.8327 9.35458C7.70752 9.4007 7.57576 9.41388 7.43741 9.42047C7.20023 9.41388 7.00258 9.36776 6.85105 9.26894C6.68635 9.16353 6.55458 9.02517 6.46235 8.86047C6.37011 8.69576 6.29764 8.49811 6.2647 8.2807C6.23176 8.06329 6.212 7.83929 6.212 7.62188V7.444C6.212 7.21341 6.23176 6.996 6.2647 6.77858V6.77858ZM7.52964 0.941406C3.89294 0.941406 0.941406 3.89294 0.941406 7.52964C0.941406 11.1663 3.89294 14.1179 7.52964 14.1179C11.1663 14.1179 14.1179 11.1663 14.1179 7.52964C14.1179 3.89294 11.1663 0.941406 7.52964 0.941406ZM7.52964 12.8002C4.62423 12.8002 2.25905 10.4351 2.25905 7.52964C2.25905 4.62423 4.62423 2.25905 7.52964 2.25905C10.4351 2.25905 12.8002 4.62423 12.8002 7.52964C12.8002 10.4351 10.4351 12.8002 7.52964 12.8002Z"
                fill="#B3B3B3"
              />
            </svg>
            Uncut Gems, All rights reserved
          </div>
          <div className="col-12 col-lg-4 text-center text-lg-end">
            Made with ❤️ by{" "}
            <a
              href="https://aveosoftware.ca/"
              style={{
                color: "#B3B3B3",
              }}
              target="_blank"
              className="text-decoration-underline"
            >
              AveoSoftware
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LoginFooter;
